import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import type { DocHandle } from "../sync/docManager";
import { useStarter } from "../tracking/starter";
import { stopTracking } from "../tracking/timelog";
import { readTask } from "../core/tasks";
import { useToasts } from "../ui/toasts";

/** When the "just 5 minutes" alarm fires: one toast, two choices, nothing modal (spec §9.19). */
export function StarterAlarm({ core }: { core: DocHandle | null }) {
  const { t } = useTranslation();
  const fired = useStarter((s) => s.fired);
  const dismiss = useStarter((s) => s.dismiss);
  const push = useToasts((s) => s.push);
  useEffect(() => {
    if (!fired || !core) return;
    const title = readTask(core.doc, fired.taskId)?.title ?? "";
    const id = push(t("starter.fired", { title }), {
      ms: 30_000,
      action: {
        label: t("starter.stopAndLog"),
        run: () => void stopTracking(core.doc),
      },
    });
    dismiss();
    return () => void id;
  }, [fired, core, push, dismiss, t]);
  return null;
}
